import { ServiceDefaultNameInterface } from "@/api/Interfaces/ServiceDefaultNameInterface";
import { GetterTree } from "vuex";
import { RootState } from "../types";
import { GlobalSearchState } from "./types";

export const getters: GetterTree<GlobalSearchState, RootState> = {
  getZipCodeSearchCheck(state): boolean {
    return state.zipCodeSearchCheck;
  },
};
